@keyframes bigToSmall {
  from {
    transform: scale3d(1.5, 1.5, 1.5);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
}

.bigToSmall {
  animation-name: bigToSmall;
}

/*before animate*/
.beforebigToSmall {
  transform: scale3d(1.5,1.5,1.5);
}

.beforebounce {
  animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  transform: translate3d(0,0,0);
}

.beforeflash {
  opacity: 1;
}

.beforebounceInDown {
  opacity: 0 !important;
  transform: translate3d(0, -3000px, 0);
}

.beforebounceInLeft {
  opacity: 0 !important;
  transform: translate3d(-3000px, 0, 0);
}

.beforebounceInRight {
  opacity: 0 !important;
  transform: translate3d(3000px, 0, 0);
}

.beforebounceInUp {
  opacity: 0 !important;
  transform: translate3d(0, 3000px, 0);
}

.beforefadeIn {
  opacity: 0 !important;
}

.beforefadeInDown {
  opacity: 0 !important;
  transform: translate3d(0, -2000px, 0);
}

.beforefadeInDownBig {
  opacity: 0 !important;
  transform: translate3d(-100%, 0, 0);
}

.beforefadeInLeft {
  opacity: 0 !important;
  transform: translate3d(-2000px, 0, 0);
}

.beforefadeInRight {
  opacity: 0 !important;
  transform: translate3d(100%, 0, 0);
}

.beforefadeInRightBig {
  opacity: 0 !important;
  transform: translate3d(2000px, 0, 0);
}

.beforefadeInUp {
  opacity: 0 !important;
  transform: translate3d(0, 100%, 0);
}

.beforefadeInUpBig {
  opacity: 0 !important;
  transform: translate3d(0, 2000px, 0);
}

.beforeflip {
  transform: perspective(400px) rotate3d(0, 1, 0, -360deg);
  animation-timing-function: ease-out;
}

.beforeflipInX {
  transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
  animation-timing-function: ease-in;
  opacity: 0 !important;
}

.beforeflipInY {
  transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
  animation-timing-function: ease-in;
  opacity: 0 !important;
}

.beforeflipOutX, .beforeflipOutY {
  transform: perspective(400px);
}

.beforelightSpeedIn {
  transform: translate3d(100%, 0, 0) skewX(-30deg);
  opacity: 0 !important;
}

.beforerotateIn {
  transform-origin: center;
  transform: rotate3d(0, 0, 1, -200deg);
  opacity: 0 !important;
}

.beforerotateInDownLeft {
  transform-origin: left bottom;
  transform: rotate3d(0, 0, 1, -45deg);
  opacity: 0 !important;
}

.beforerotateInDownRight {
  transform-origin: right bottom;
  transform: rotate3d(0, 0, 1, 45deg);
  opacity: 0 !important;
}

.beforerotateInUpLeft {
  transform-origin: left bottom;
  transform: rotate3d(0, 0, 1, 45deg);
  opacity: 0 !important;
}

.beforerotateInUpRight {
  transform-origin: right bottom;
  transform: rotate3d(0, 0, 1, -90deg);
  opacity: 0 !important;
}

.beforejackInTheBox {
  opacity: 0 !important;
  transform: scale(0.1) rotate(30deg);
  transform-origin: center bottom;
}

.beforerollIn {
  opacity: 0 !important;
  transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);
}

.beforezoomIn {
  opacity: 0 !important;
  transform: scale3d(.3, .3, .3);
}

.beforezoomInDown {
  opacity: 0 !important;
  transform: scale3d(.1, .1, .1) translate3d(0, -1000px, 0);
  animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
}

.beforezoomInLeft {
  opacity: 0 !important;
  transform: scale3d(.1, .1, .1) translate3d(-1000px, 0, 0);
  animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
}

.beforezoomInRight {
  opacity: 0 !important;
  transform: scale3d(.1, .1, .1) translate3d(1000px, 0, 0);
  animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
}

.beforezoomInUp {
  opacity: 0 !important;
  transform: scale3d(.1, .1, .1) translate3d(0, 1000px, 0);
  animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);
}

.beforeslideInDown {
  transform: translate3d(0, -100%, 0);
  visibility: visible;
}

.beforeslideInLeft {
  transform: translate3d(-100%, 0, 0);
  visibility: visible;
}

.beforeslideInRight {
  transform: translate3d(100%, 0, 0);
  visibility: visible;
}

.beforeslideInUp {
  transform: translate3d(0, 100%, 0);
  visibility: visible;
}



// WEBPACK FOOTER //
// ./assets/css/customAnimations.css